import { InjectionToken } from '@angular/core';
import { FeedbackGateway } from '@prlw/core/feedback/feedback-gateway.interface';

export const FEEDBACK_GATEWAY = new InjectionToken<FeedbackGateway>(
  'feedback-gateway',
);
